import domReady from '@wordpress/dom-ready';

/**
 * @link https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/tab_role
 */
const initializeTabs = ( tabGroup ) => {
	const tabList = tabGroup.querySelector( ':scope [role="tablist"]' );
	const tabs = tabList.querySelectorAll( ':scope [role="tab"]' );
	const tabPanels = tabGroup.querySelectorAll( ':scope [role="tabpanel"]' );
	let tabFocus = 0;

	const changeTab = ( e ) => {
		if ( ! e.target.matches( '[role="tab"]' ) ) {
			return;
		}

		const targetTab = e.target;

		// Remove all current selected tabs.
		tabList
			.querySelectorAll( ':scope > [aria-selected="true"]' )
			.forEach( ( t ) => t.setAttribute( 'aria-selected', false ) );

		// Set this tab as selected.
		targetTab.setAttribute( 'aria-selected', true );

		// Hide all tab panels.
		tabPanels.forEach( ( p ) => p.setAttribute( 'hidden', true ) );

		// Show the selected panel.
		tabGroup
			.querySelector( `#${ targetTab.getAttribute( 'aria-controls' ) }` )
			.removeAttribute( 'hidden' );
	};

	tabList.addEventListener( 'click', changeTab );

	if ( 'hover' === tabGroup.dataset.selectMode ) {
		tabList.addEventListener( 'mouseover', changeTab );
	}

	tabList.addEventListener( 'keydown', ( e ) => {
		if ( e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' ) {
			return;
		}

		tabs[ tabFocus ].setAttribute( 'tabindex', -1 );

		if ( e.key === 'ArrowRight' ) {
			tabFocus++;
			// If we're at the end, go to the start.
			if ( tabFocus >= tabs.length ) {
				tabFocus = 0;
			}
		} else if ( e.key === 'ArrowLeft' ) {
			tabFocus--;
			// If we're at the start, move to the end.
			if ( tabFocus < 0 ) {
				tabFocus = tabs.length - 1;
			}
		}

		tabs[ tabFocus ].setAttribute( 'tabindex', 0 );
		tabs[ tabFocus ].focus();
	} );
}

domReady( () => {
	document.querySelectorAll( '.wp-block-sims-tabs' ).forEach( initializeTabs );
} );
